export class CorridorLevel {
    constructor(public max?: string, public min?: string) {}
}
